/* NONZO — nz-cards.js
   Handles .nz-card on both homepage and shop page.
   Behaviour:
     - Color swatch click  → swap image, link/title, PRICE (incl. sale strikethrough),
                             reset carousel to image 0, toggle Sold out badge
     - Arrow click         → cycle through current color's images
*/
(function () {
  'use strict';

  function egp(x){ return (x || '').replace('LE ', 'EGP '); }

  function injectStyle(){
    if (document.getElementById('nz-card-price-style')) return;
    var st = document.createElement('style');
    st.id = 'nz-card-price-style';
    st.textContent = '.nz-card__price--sale{color:#6b1a2c;}.nz-card__price--was{color:#9a9a9a;text-decoration:line-through;margin-left:7px;font-size:0.9em;}';
    document.head.appendChild(st);
  }

  function initCards() {
    injectStyle();
    document.querySelectorAll('.nz-card').forEach(function (card) {
      var imgEl    = card.querySelector('[data-nz-img]');
      var imgLink  = card.querySelector('.nz-card__img-link');
      var nameLink = card.querySelector('.nz-card__name-link');
      var titleEl  = card.querySelector('[data-nz-title]');
      var priceEl  = card.querySelector('[data-nz-price]');
      var soldEl   = card.querySelector('[data-nz-soldout]');
      var swatches = card.querySelectorAll('.nz-card__swatch');
      var prevBtn  = card.querySelector('[data-nz-prev]');
      var nextBtn  = card.querySelector('[data-nz-next]');

      var imgs = [];
      var idx  = 0;

      function setPrice(sw){
        if (!priceEl || !sw) return;
        var p = egp(sw.dataset.price || '');
        var c = egp(sw.dataset.compare || '');
        if (!p) return;
        if (c) {
          priceEl.innerHTML = '<span class=\"nz-card__price--sale\">' + p + '</span><s class=\"nz-card__price--was\">' + c + '</s>';
        } else {
          priceEl.textContent = p;
        }
      }

      var activeSwatch = card.querySelector('.nz-card__swatch.is-active');
      if (activeSwatch && activeSwatch.dataset.imgs) {
        imgs = activeSwatch.dataset.imgs.split('|').filter(Boolean);
      }
      if (!imgs.length && imgEl) {
        imgs = [imgEl.getAttribute('src')];
      }
      if (activeSwatch) setPrice(activeSwatch);

      function goTo(n) {
        if (!imgEl || !imgs.length) return;
        idx = ((n % imgs.length) + imgs.length) % imgs.length;
        imgEl.src    = imgs[idx];
        imgEl.srcset = '';
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(idx - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(idx + 1);
        });
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          var newImgsPipe = sw.dataset.imgs  || '';
          var newImg      = sw.dataset.img   || '';
          var newHref     = sw.dataset.href  || '';
          var newTitle    = sw.dataset.title || '';

          var newImgs = newImgsPipe ? newImgsPipe.split('|').filter(Boolean) : [];
          if (!newImgs.length && newImg) newImgs = [newImg];

          imgs = newImgs;
          idx  = 0;
          if (imgEl && imgs.length) {
            imgEl.src    = imgs[0];
            imgEl.srcset = '';
          }

          if (newHref) {
            if (imgLink)  imgLink.setAttribute('href',  newHref);
            if (nameLink) nameLink.setAttribute('href', newHref);
          }

          if (titleEl && newTitle) titleEl.textContent = newTitle;

          setPrice(sw);

          if (soldEl) {
            soldEl.style.display = (sw.dataset.soldout === '1') ? 'block' : 'none';
          }

          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCards);
  } else {
    initCards();
  }
})();